import { ComponentType } from 'react'
import { RoleModel } from 'utils/role'
import { Categories } from './categories'
import { Footer } from './footer'
import { Hero } from './hero'

interface Props {
  role: RoleModel
}

export const ExploreRole: ComponentType<Props> = ({ role }) => (
  <>
    <Hero role={role} />
    <Categories role={role} />
    <Footer />
  </>
)
